<template>
  <div
    v-if="fields && fields.code"
    :field="fields.code"
    class="wistia_responsive_padding"
    style="padding: 56.25% 0 0 0; position: relative"
  >
    <div
      class="wistia_responsive_wrapper"
      style="height: 100%; left: 0; position: absolute; top: 0; width: 100%"
    >
      <div
        :class="`wistia_embed wistia_async_${fields.code.value} seo=false videoFoam=true`"
        style="height: 100%; position: relative; width: 100%"
      >
        <div
          class="wistia_swatch"
          style="
            height: 100%;
            left: 0;
            opacity: 0;
            overflow: hidden;
            position: absolute;
            top: 0;
            transition: opacity 200ms;
            width: 100%;
          "
        >
          <img
            style="filter: blur(5px); height: 100%; object-fit: contain; width: 100%"
            :src="`https://fast.wistia.com/embed/medias/${fields.code.value}/swatch`"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CIS-Wistia-Video',
  components: {},
  props: {
    fields: {
      type: Object
    }
  },
  mounted() {
    if (this.fields.code) {
      let wistiaJsonp = document.createElement('script');
      wistiaJsonp.setAttribute(
        'src',
        'https://fast.wistia.com/embed/medias/' + this.fields.code + '.jsonp'
      );
      document.head.appendChild(wistiaJsonp);
    }

    let wistiaScript = document.createElement('script');
    wistiaScript.setAttribute('src', 'https://fast.wistia.com/assets/external/E-v1.js');
    document.head.appendChild(wistiaScript);
  }
};
</script>
